import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Intro from "./sections/Intro";
import Join from "./sections/Join";
import Company from "./sections/Company";
import Request from "./sections/Request";
import Event from "./sections/Event";
import Partner from "./sections/Partner";
import Head from "../Base/Head";

export default function UNGA({ event }) {
  const [gradientReady, setGradientReady] = useState(false);
  const head = {
    title: "Social Innovation Summit @ UNGA 2026",
    description:
      "Social Innovation Summit, along with our partners, are delighted to host a series of VIP events for our network of corporate responsibility executives, philanthropists, investors, nonprofit leaders, policymakers, celebrity activists, and social entrepreneurs across the global impact ecosystem during UN General Assembly week 2026!",
    url: "https://unga.socialinnovation.com",
    image: "https://i.ibb.co/sJHFTBdB/unga-2026-twitter-card.jpg",
  };

  return (
    <>
      <Head head={head} />
      <div
        className={`events-wrapper unga-wrapper sisvip-wrapper redesign unga26 ${
          gradientReady ? "gradient-ready" : ""
        }`}
      >
        <Intro event={event} />
        {/* <Join /> */}
        {/* <Event /> */}
        <Request event={event} onOptionsLoadedChange={setGradientReady} />
        {/* <Company /> */}
        {/* <Partner /> */}
      </div>
    </>
  );
}
